import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { email } from './validator';

@Directive({
    selector: '[emailWithDot][formControlName],[emailWithDot][formControl],[emailWithDot][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EmailValidatorDirective),
            multi: true,
        },
    ],
})
export class EmailValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = email();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
